module.exports = __webpack_public_path__ + "img/circle.4aff3ab1.png";